import { useMemo } from 'react';

import { useParams } from 'react-router-dom';

import { PathParams } from '@app/routes/types';

export const useGameSlug = (): string => {
    const { [PathParams.CompetitionSlug]: slugParam } = useParams();
    return useMemo(() => slugParam || '', [slugParam]);
};
